module.exports = __webpack_public_path__ + "static/media/icnBtnEditar.a477191a.svg";